import { Link, useLocation, useParams } from "react-router-dom";
import navlogo from "../../Assets/Icons/zerozerologo.png";
import { useEffect } from "react";

import "./Header.css";

import { BiUser } from "react-icons/bi";
import { RiShoppingBag2Line } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";

import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";

import { useState } from "react";
import Login from "../../Authentication/Login";
import { setCart, setLoading, showAuth } from "../../Redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authPage } from "../../Redux/action";
import toast, { Toaster } from "react-hot-toast";
import apiRequest from "../../apiCall";
// import GetAllProducts, { GetProductById, getProductsFromCartById } from "../../Admin/callApi/shop";


export default function Navbar() {
  
  
  const [quantitycount, setQuantitycount] = useState({ TotalQuantity: 0 });

  const location = useLocation();

  const [productName, setProductName] = useState("")

  // extract the product name from the location.pathname
  const product = location.pathname.slice(6)
  // console.log("location111", location.pathname, "name", productName, "product slice", product)
  

  // get product name by id
  // React.useEffect(()=>{
  //   GetProductById(product)
  //   .then((res)=>{
  //     // console.log("res in header", res)
  //     setProductName(res[0]?.ProductCode.replaceAll(" ", "%20"))
  //   })
  //   .catch((error)=>{
  //     console.error("Something went wrong", error)
  //   })



  //   getProductsFromCartById(userData?.id)
  //     .then((res) => {
  //       console.log("cartttt size", res.length);
       
  //       dispatch(setCart(res.length))
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching the data", error);
  //     });
  // },[location])


  const [anchorEl, setAnchorEl] = React.useState(null);

  const [islogin, setIsLogin] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setIsLogin(islogin);
    if (islogin) {
      setAnchorEl(event.currentTarget);
    } else {
    }
  };

  const storedData = localStorage.getItem("userData") || " {}";
  const userData = JSON.parse(storedData);
  const firstName = userData.FirstName || null;



   const CustomerId = userData.id || null;
  const cartItems = useSelector((state)=>state.cart.cartItems)

  const navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const [isLoginVisible, setLoginVisible] = useState(false);
  const togglePopup = () => {
    setLoginVisible(!isLoginVisible);
  };

  const [showPopup, setShowPopup] = useState(false);


  const handleLogout = () => {
    dispatch(setLoading(true))
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    // window.location.reload();
    setShowPopup(!showPopup);
    navigate("/");
    toast.success("Logged out successfully")
    dispatch(setLoading(false))
    
      setShowPopup(!showPopup);
  
  };


  const handleCartClick = () => {

    let userToken = localStorage.getItem("userToken")
    // console.log("token", userToken)
    if(userToken == null || userToken == {}){
      dispatch(showAuth(true));
      dispatch(authPage("login"));
    } else{
      navigate("/cart")
    }
  }

  useEffect(() => {
   
      apiRequest("GET", `quantitycount/${CustomerId}`, null, false, false)
        .then((response) => {
          setQuantitycount(response[0]);
          dispatch(setCart(false));
        })
        .catch((error) => {
          console.log(error);
        });
    
  }, [CustomerId,cartItems, dispatch]);

  useEffect(()=>{
    dispatch(setCart(true));
  },[])

  const handleNavItemClick = () =>{
    setIsOpen(false)
  }

  return (

    <div className="mainheader">
      <div className="header-container">
        <div className="top-offer"></div>

        <div className="navbar">
          <div className="toggal-btn" onClick={toggleNavbar}>
            <GiHamburgerMenu />
          </div>
          <div className="nav-logo">
            <img src={navlogo} alt="zero zero" />
          </div>

          <nav>
            <ul className={isOpen ? "visible" : "hidden"} id="navigation">
              <li onClick={handleNavItemClick}>
                <Link
                  to="/"
                  className={
                    location.pathname === "/" ? "nav-link active" : "nav-link"
                  }
                >
                  Home
                </Link>
              </li>
              <li onClick={handleNavItemClick}>
                <Link
                  to='/shop'
                  className={
                    location.pathname === `/shop/${product}`
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Shop
                </Link>
              </li>

              <li onClick={handleNavItemClick}>
                <Link
                  to="/about"
                  className={
                    location.pathname === "/about"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  About Us
                </Link>
              </li>
              <li onClick={handleNavItemClick}>
                <Link
                  to="/blog"
                  className={
                    location.pathname === "/blog"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Blog
                </Link>
              </li>
              <li onClick={handleNavItemClick}>
                <Link
                  to="/contactus"
                  className={
                    location.pathname === "/contactus"
                      ? "nav-link active"
                      : "nav-link"
                  }
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </nav>
          <div className="nav-right">
            {/* cart */}
            <p className="cart-p">
              <span className={location.pathname === "/cart" ? "nav-link active" : "nav-link"}>
                
              {quantitycount.TotalQuantity >= 1 && (
                    <span className="red-dot">
                      <h6>{quantitycount.TotalQuantity}</h6>
                    </span>
                  )}
                <RiShoppingBag2Line onClick={handleCartClick} style={{cursor:"pointer"}} title="Cart"/>
               
              </span>
              <span>
                {localStorage.getItem("userToken") === null ? (
                  <BiUser
                    title="Profile"
                    onClick={() => {
                      dispatch(showAuth(true));
                      dispatch(authPage("login"));
                    }}
                    style={{cursor:"pointer"}}
                  />
                ) : (
                  <span
                    className="headerfirstname"
                    onClick={() => {
                      setShowPopup(!showPopup);
                    }}
                  >
                    {firstName}
                  </span>
                )}
              </span>
              {showPopup && (
                <div className="user-popup">
                  <button
                    className="delete-cart alignment"
                    onClick={() => setShowPopup(!showPopup)}
                  >
                    <b>X</b>
                  </button>
                  <ul>
                    <li onClick={() => {
                      setShowPopup(!showPopup);
                    }}>
                      <Link
                        to="/myprofile"    
                      >
                        My Profile
                      </Link>
                    </li>
                    <li onClick={() => {
                      setShowPopup(!showPopup);
                    }}>
                      <Link
                        to="/myorders"
                      >
                        My Orders
                      </Link>
                    </li>
                    {/* <li><Link to="/resetPassword">
                    Change Password</Link></li> */}
                    <li onClick={handleLogout} style={{ cursor: "pointer" }}>
                      <Link>Logout</Link>
                    </li>
                  </ul>
                </div>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
